import React from 'react';
import { NavBar } from '../../Modules/Navigation/components/NavBar/NavBar';
import PageContentCardContainer from '../../ui/Layout/PageContentCardContainer/PageContentCardContainer';
import ArtistsAdmin from '../../Modules/Artist/features/ArtistsAdmin/ArtistsAdmin';

const ArtistAdminPage = () => (
    <>
        <NavBar />
        <PageContentCardContainer>
            <ArtistsAdmin />
        </PageContentCardContainer>
    </>
);

export default ArtistAdminPage;
